// src/lib/fernetUtils.ts
// Utilitaires de chiffrement/déchiffrement utilisant fernet-web
// Installation : npm i fernet-web

import Fernet from "fernet-web";

/**
 * Déchiffre un token Fernet (UTF-8) avec la clé Base64 du praticien.
 * Renvoie le texte en clair.
 */
export async function decryptFernet(keyB64: string, token: string): Promise<string> {
  try {
    const f = await Fernet.create(keyB64);   // WebCrypto init
    return f.decrypt(token);
  } catch {
    throw new Error("Decryption failed");
  }
}

/**
 * Chiffre un texte avec la clé Base64 du praticien.
 * Renvoie le token Fernet Base64.
 */
export async function encryptFernet(keyB64: string, plaintext: string): Promise<string> {
  const f = await Fernet.create(keyB64);
  return f.encrypt(plaintext);
}
